import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
// components
import { ModalContainer } from '../../containers'
import { ModalContainer2 } from '../../components/organism/Modals'

@Component({
  components: { ModalContainer, ModalContainer2 },
})
export default class BaseLayout extends Vue {
  //
  // ────────────────────────────────────────────────── I ──────────
  //   :::::: P R O P S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────
  //

  @Prop({ type: String }) classNames!: string

  logoutLoad() {
    let iframe = document.getElementById('iframe_logout') as HTMLIFrameElement
    if (iframe.src.indexOf('adfs') > -1)
      this.$router.push({ name: 'login' })
  }
}
